/**
 * Centralised external URLs used across the UI.
 *
 * Confluence links use the stable page-ID format so they survive page renames.
 * If a page is deleted and re-created, only this file needs updating.
 */

// ---------------------------------------------------------------------------
// Confluence / Documentation
// ---------------------------------------------------------------------------

export const DOCS = {
  /** ChatMCP overview wiki page */
  CHATMCP:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=16818438164',

  /** Agent docs – Creating an Agent */
  AGENT_CREATE:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=18287460683',

  /** Agent docs – Updating an Agent */
  AGENT_UPDATE:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=18308301022',

  /** Agent docs – Registering an Agent */
  AGENT_REGISTER:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=18308039143',

  /** Semantic View docs – Creating a Semantic View */
  SEMANTIC_VIEW_CREATE:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=18231820346',

  /** Semantic View docs – Registering Semantic Views */
  SEMANTIC_VIEW_REGISTER:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=18258395172',

  /** Semantic View docs – Editing a Semantic View */
  SEMANTIC_VIEW_EDIT:
    'https://cimpress-support.atlassian.net/wiki/pages/viewpage.action?pageId=18258198585',
} as const;

// ---------------------------------------------------------------------------
// Cimpress internal services
// ---------------------------------------------------------------------------

export const CIMPRESS = {
  /** COAM group details page (append group ID) */
  COAM_GROUP: 'https://users.cimpress.io/groups',
} as const;

// ---------------------------------------------------------------------------
// Snowflake app URL builders
// ---------------------------------------------------------------------------

const SNOWFLAKE_APP_BASE = 'https://app.snowflake.com';

export const snowflakeUrls = {
  /** Link to edit a staged semantic model YAML in Snowflake Studio */
  stageModelEdit: (
    org: string,
    account: string,
    database: string,
    schema: string,
    stage: string,
    modelId: string,
  ) =>
    `${SNOWFLAKE_APP_BASE}/${org}/${account}/#/studio/analyst/databases/${database}/schemas/${schema}/stages/${stage}/${modelId}.yaml/edit`,

  /** Link to a semantic view in Snowflake Studio */
  semanticView: (
    org: string,
    account: string,
    database: string,
    schema: string,
    viewName: string,
  ) =>
    `${SNOWFLAKE_APP_BASE}/${org}/${account}/#/studio/analyst/databases/${database}/schemas/${schema}/semanticView/${viewName}`,

  /** Link to an agent's details page in Snowflake */
  agentDetails: (
    org: string,
    account: string,
    database: string,
    schema: string,
    agentName: string,
  ) =>
    `${SNOWFLAKE_APP_BASE}/${org}/${account}/#/agents/database/${database}/schema/${schema}/agent/${agentName}/details`,
} as const;
